import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import { ListWithPagination } from 'dash-ui';
import { PortfolioFolderItemFragment } from 'gql/generated.graphql';

import PortfolioCardItem from './components/PortfolioPropertyCardItem/PortfolioPropertyCardItem';

const StyledList = styled(ListWithPagination)`
  & > div:first-child {
    padding: 0;
    border: none;
    width: 100%;
  }
  & > div:last-child {
    justify-content: center;
  }
  & .portfolio-properties-list-view {
    width: 100%;
  }
`;

const PortfolioPropertiesListView = ({
  portfolioItems,
  loading,
}: {
  portfolioItems: PortfolioFolderItemFragment[];
  loading: boolean;
}) => {
  const theme = useTheme();
  const { t } = useTranslation('common');

  return (
    <StyledList
      listProps={{
        data: portfolioItems,
        gap: 16,
        containerClassName: 'portfolio-properties-list-view',
        minHeight: 150,
        grid: [343, 385, 356, 356],
        loading,
        loadingProps: { bgColor: theme.colors.b10 },
      }}
      paginationProps={{
        nextButtonLabel: t('common:labels.next'),
        previousButtonLabel: t('common:labels.previous'),
      }}
    >
      {(portfolioItem) => <PortfolioCardItem portfolioItem={portfolioItem} />}
    </StyledList>
  );
};

export default PortfolioPropertiesListView;
